import API from "./API";
import { sessionRenewApi } from "./sessionRenewApi";

export const demandInfo = async (payload) => {
  try {
    return await API.post("/sems/demand_history", payload);
  } catch (error) {
     if (error.response && error.response.status === 403) {
      await sessionRenewApi();
      return API.post("/sems/demand_history", payload);
    }
    throw error;
  }
};